import { faArrowLeft } from '@skeepers/skeepers-icons/solid/faArrowLeft';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import RoundedButton from '@components/Common/RoundedButton';

import style from './style.module.css';


const PreviousButton = ({ onClick = () => {}, classNames: cn }) => {
  return <RoundedButton
    icon={faArrowLeft}
    backgroundColor="var(--primary-color)"
    className={classNames(style.button, cn)}
    onClick={onClick}
  />;
};

export default PreviousButton;

PreviousButton.propTypes = {
  onClick: PropTypes.func,
};
